/**
 * The public plan gallery (`D274`): route functions, the key and the
 * mutations. Online only, never the outbox (`D163`); both writes are
 * idempotent. Opening an entry is `D273`'s preview (`sharedPlanOptions`).
 */
import { galleryOfferOutput, galleryOutput, offerToGalleryPath, PLAN_GALLERY_ROUTES, reportGalleryPath, } from "@repo/contract/community";
import { z } from "zod";
import { getJson, sendJson, } from "../core/request";
export const galleryKeys = {
    gallery: () => ["community", "gallery"],
};
export function fetchGallery(api, init) {
    return getJson(api, PLAN_GALLERY_ROUTES.gallery, galleryOutput, init);
}
export function galleryOptions(api) {
    return {
        queryFn: ({ signal }) => fetchGallery(api, { signal }),
        queryKey: galleryKeys.gallery(),
        staleTime: 5 * 60_000,
    };
}
export function offerToGalleryMutation(api) {
    return {
        mutationFn: ({ shareId, title }) => sendJson(api, "POST", offerToGalleryPath(shareId), { title }, galleryOfferOutput),
        mutationKey: ["community", "gallery", "offer"],
    };
}
const reportedOutput = z.object({ reported: z.literal(true) });
export function reportGalleryMutation(api) {
    return {
        mutationFn: (shareId) => sendJson(api, "POST", reportGalleryPath(shareId), undefined, reportedOutput),
        mutationKey: ["community", "gallery", "report"],
    };
}
//# sourceMappingURL=gallery.js.map